import { render, staticRenderFns } from "./FollowersItem.vue?vue&type=template&id=22c0e397&"
import script from "./FollowersItem.vue?vue&type=script&lang=ts&"
export * from "./FollowersItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports